<template>
  <BaseModal
    name="addModelModal"
    width="420"
    :clickToClose="false"
    :shiftY="0.5"
    @before-close="beforeClose"
    @before-open="loadData"
    :adaptive="true"
    height="auto"
    classes="!tw-bg-transparent !tw-shadow-none"
  >
    <div
      class="tw-bg-white tw-rounded-[25px] tw-py-[38px] tw-px-[30px] tw-relative tw-text-forTitle"
    >
      <BaseLoader v-if="localLoading" class="tw-rounded-[25px]"></BaseLoader>
      <button
        type="button"
        class="btn-close tw-absolute tw-right-[30px] tw-top-[20px] !tw-shadow-none"
        @click="$modal.hide('addModelModal')"
      ></button>
      <div>
        <div
          class="tw-text-center tw-text-[23px] tw-mb-[15px]"
          v-if="!this.currentId"
        >
          Добавить новую модель
        </div>
        <div
          class="tw-text-center tw-text-[23px] tw-mb-[15px]"
          v-if="this.currentId"
        >
          Редактировать модель
        </div>
        <div
          class="mb-10 d-flex justify-content-between align-items-center wp-100"
          ref="vehicle_marks__name"
          v-if="!localLoading"
        >
          <span class="text-muted fsc-11">{{
            dataLang["vehicle_marks__name"]
          }}</span>
          <div class="multiselect-type-2">
            <BaseSelect
              :options="selectsOptions.vehicle_marks__name"
              placeholder=""
              label="vehicle_marks__name"
              style="width: 188px"
              selectLabel=""
              @select="
                (data) =>
                  updateValue({
                    name: 'vehicle_examples__mark_id',
                    value: data.vehicle_marks__id,
                  })
              "
              v-model="selectsData.vehicle_marks__name"
            >
              <template slot="noOptions">{{
                dataLang["select_empty"]
              }}</template>
              <template slot="noResult">{{
                dataLang["select_search_empty"]
              }}</template>
              <template slot="selectedLabel">{{
                dataLang["select_selected"]
              }}</template>

              <template slot="deselectLabel">{{
                dataLang["select_unselect"]
              }}</template>
            </BaseSelect>
          </div>
        </div>
        <div ref="vehicle_examples__model" class="wp-100 mb-10">
          <BaseInputNew
            inputClass="tw-app-input-type-2"
            placeholder=""
            class="lh-1 wp-100"
            input-name="vehicle_examples__model"
            signClass="d-flex "
            @input="updateValue"
            openDirection="bottom"
            :horizontalTitle="true"
            width="190"
            :value="dataForEmit.vehicle_examples__model"
            :additionalParams="{}"
            :name-sign="dataLang?.vehicle_examples__name"
          />
        </div>
        <div ref="vehicle_examples__model" class="wp-100 mb-10">
          <BaseInputNew
            inputClass="tw-app-input-type-2"
            placeholder=""
            class="lh-1 wp-100"
            input-name="car_examples__body_generation"
            signClass="d-flex "
            @input="updateValue"
            openDirection="bottom"
            :horizontalTitle="true"
            width="190"
            :value="dataForEmit.car_examples__body_generation"
            :additionalParams="{}"
            :name-sign="dataLang?.car_examples__body_generation"
          />
        </div>
        <div
          class="mb-10 d-flex justify-content-between align-items-center wp-100"
          ref="car_examples__body_type"
          v-if="!localLoading"
        >
          <span class="text-muted fsc-11">{{
            dataLang["car_examples__body_type"]
          }}</span>
          <div class="multiselect-type-2">
            <BaseSelect
              :options="selectsOptions.car_examples__body_type"
              placeholder=""
              label="label"
              style="width: 188px"
              selectLabel=""
              @select="
                (data) => updateValue({ name: data.key, value: data.value })
              "
              v-model="selectsData.car_examples__body_type"
            >
              <template slot="noOptions">{{
                dataLang["select_empty"]
              }}</template>
              <template slot="noResult">{{
                dataLang["select_search_empty"]
              }}</template>
              <template slot="selectedLabel">{{
                dataLang["select_selected"]
              }}</template>
              <template slot="deselectLabel">{{
                dataLang["select_unselect"]
              }}</template>
            </BaseSelect>
          </div>
        </div>
        <div ref="car_examples__count_doors" class="wp-100 mb-10">
          <BaseInputNew
            inputClass="tw-app-input-type-2"
            placeholder=""
            class="lh-1 wp-100"
            input-name="car_examples__count_doors"
            signClass="d-flex "
            @input="updateValue"
            :horizontalTitle="true"
            width="190"
            :value="dataForEmit.car_examples__count_doors"
            :additionalParams="{}"
            :name-sign="dataLang?.car_examples__count_doors"
          />
        </div>
        <div ref="car_examples__count_places" class="wp-100 mb-10">
          <BaseInputNew
            inputClass="tw-app-input-type-2"
            placeholder=""
            class="lh-1 wp-100"
            input-name="car_examples__count_places"
            signClass="d-flex "
            @input="updateValue"
            width="190"
            :horizontalTitle="true"
            :value="dataForEmit.car_examples__count_places"
            :additionalParams="{}"
            :name-sign="dataLang?.car_examples__count_places"
          />
        </div>
        <div ref="car_examples__trunk_volume" class="wp-100 mb-10">
          <BaseInputNew
            inputClass="tw-app-input-type-2"
            placeholder=""
            class="lh-1 wp-100"
            input-name="car_examples__trunk_volume"
            signClass="d-flex "
            @input="updateValue"
            width="190"
            :horizontalTitle="true"
            :value="dataForEmit.car_examples__trunk_volume"
            :additionalParams="{}"
            :name-sign="dataLang?.car_examples__trunk_volume"
          />
        </div>
        <div ref="car_examples__ground_clearance" class="wp-100 mb-10">
          <BaseInputNew
            inputClass="tw-app-input-type-2"
            placeholder=""
            class="lh-1 wp-100"
            input-name="car_examples__ground_clearance"
            signClass="d-flex "
            @input="updateValue"
            width="190"
            :horizontalTitle="true"
            :value="dataForEmit.car_examples__ground_clearance"
            :additionalParams="{}"
            :name-sign="dataLang?.car_examples__ground_clearance"
          />
        </div>
        <div ref="car_examples__tank_capacity" class="wp-100 mb-15">
          <BaseInputNew
            inputClass="tw-app-input-type-2"
            placeholder=""
            class="lh-1 wp-100"
            width="190"
            input-name="car_examples__tank_capacity"
            signClass="d-flex "
            @input="updateValue"
            :horizontalTitle="true"
            :value="dataForEmit.car_examples__tank_capacity"
            :additionalParams="{}"
            :name-sign="dataLang?.car_examples__tank_capacity"
          />
        </div>
        <p class="text-center fsc-11 text-danger mb-15" v-if="errorMessage">
          {{ errorMessage }}
        </p>
        <div class="tw-flex tw-gap-[10px] tw-mt-[15px] tw-justify-center">
          <button
            class="tw-app-btn-muted tw-app-btn-muted-lg"
            @click="$modal.hide('addModelModal')"
          >
            {{ dataLang["reg_fin_text_57"] }}
          </button>
          <button
            @click="sendData"
            class="tw-app-btn-primary tw-app-btn-primary-lg"
          >
            {{ dataLang["reg_fin_text_58"] }}
          </button>
        </div>
      </div>
    </div>
  </BaseModal>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";
import GeneralService from "@/api/GeneralService.js";
import { VeTable } from "vue-easytable";
import EventBus from "@/event-bus.js";
import StorageFileService from "@/api/StorageFileService";
import { find } from "lodash";
export default {
  components: {
    VeTable,
  },

  props: {},
  data() {
    return {
      selectsData: {
        vehicle_marks__name: [],
        car_examples__body_type: [],
        car_examples__count_doors: [],
        car_examples__count_places: [],
      },
      selectsOptions: {
        vehicle_marks__name: [],
        car_examples__body_type: [],
        car_examples__count_doors: [],
        car_examples__count_places: [],
      },
      errorMessage: "",
      localLoading: false,
      typeOperation: "",
      dataForEmit: {},
      currentId: null,
      loadCallback: null,
      updatedValues: [],
    };
  },
  methods: {
    loadData({ params }) {
      this.localLoading = true;
      this.currentId = params?.id;
      if (params?.callback) {
        this.loadCallback = params?.callback;
      }

      Promise.all([
        GeneralService.get(`/selects/field/car_examples__body_type`).then(
          (data) => {
            this.selectsOptions.car_examples__body_type =
              this.prepareLabelsForDefaultSelects(
                data.data.data.rows,
                "allSelects",
                true
              ).car_examples__body_type;
          }
        ),
        GeneralService.get(`/marks`).then((data) => {
          this.selectsOptions.vehicle_marks__name = data.data.data;
        }),
      ])
        .then(() => {
          if (params?.data) {
            this.dataForEmit = params?.data;
            console.log(
              params?.data,
              this.selectsOptions.car_examples__body_type
            );
            this.selectsData.vehicle_marks__name =
              this.selectsOptions.vehicle_marks__name.find(
                (valSearch) =>
                  valSearch.vehicle_marks__name ==
                  this.dataForEmit.vehicle_marks__name
              );
            this.selectsData.car_examples__body_type =
              this.selectsOptions.car_examples__body_type.find((valSearch) => {
                return (
                  this.dataLang[valSearch.value] ==
                  this.dataForEmit.car_examples__body_type
                );
              });
          }
          this.localLoading = false;
        })
        .catch((e) => console.error(e))
        .finally(() => {
          if (params?.additional?.vehicle_marks__id) {
            this.selectsData.vehicle_marks__name =
              this.selectsOptions.vehicle_marks__name.find((x) => {
                return (
                  Number(x.vehicle_marks__id) ==
                  Number(params.additional.vehicle_marks__id)
                );
              });
            this.updateValue({
              name: "vehicle_examples__mark_id",
              value: this.selectsData.vehicle_marks__name.vehicle_marks__id,
            });
          }
        });
    },
    beforeClose(event) {
      this.dataForEmit = {};
      this.currentId = null;
      this.loadCallback = null;
      this.errorMessage = "";
      this.selectsData = {
        vehicle_marks__name: [],
        car_examples__body_type: [],
        car_examples__count_doors: [],
        car_examples__count_places: [],
      };
      this.selectsOptions = {
        vehicle_marks__name: [],
        car_examples__body_type: [],
        car_examples__count_doors: [],
        car_examples__count_places: [],
      };
    },
    updateValue(data) {
      this.updatedValues[data.name] = data.value;

      if (this.$refs[data.name]) {
        this.$refs[data.name].classList.remove("input-error");
      }
    },

    delFile(name, file) {
      this.updateValue({ name: name, value: "" });
      this.loadedImage = "";
    },
    async sendData() {
      this.localLoading = true;
      if (!this.currentId) {
        GeneralService.editOrCreate(`/examples`, {
          vehicle_examples__vehicle_type: "car",
          ...this.updatedValues,
        })
          .then(async (data) => {
            // this.$toast.success(data.data.message)
            if (this.loadCallback) {
              await this.loadCallback(data);
            }
            this.dataForEmit = {};
            this.updatedValues = {};
            this.$emit("added");
            this.$modal.hide("addModelModal");
          })
          .catch((e) => {
            console.error(e);
            this.errorMessage = e.response?.data?.message;
            if (e.response?.data?.errors) {
              setTimeout(() => {
                Object.keys(e.response.data.errors).forEach((elem, index) => {
                  if (this.$refs[elem]) {
                    this.$refs[elem].classList.add("input-error");
                  }
                });
              }, 10);
            }
          })
          .finally(() => {
            this.localLoading = false;
          });
      } else {
        GeneralService.edit(`/examples/${this.currentId}`, {
          ...this.updatedValues,
        })
          .then(async (data) => {
            this.$toast.success(data.data.message);

            if (this.loadCallback) {
              await this.loadCallback();
            }
            this.dataForEmit = {};
            this.$modal.hide("addModelModal");
          })
          .catch((e) => {
            //   this.$toast.error(e.response.data.message, {duration: 5000})
            this.errorMessage = e.response?.data?.message;
            if (e.response?.data?.errors) {
              setTimeout(() => {
                Object.keys(e.response.data.errors).forEach((elem, index) => {
                  if (this.$refs[elem]) {
                    this.$refs[elem].classList.add("input-error");
                  }
                });
              }, 10);
            }
          })
          .finally(() => {
            this.localLoading = false;
          });
      }
    },
    prepareLabelsForDefaultSelects(data, keyDataFromFetch, toTranslate) {
      for (const key in data) {
        data[key].forEach((element) => {
          element["label"] = element[Object.keys(element).pop()];
          element["key"] = key;
          element["value"] = Object.keys(element)[0];
          element["selectName"] = keyDataFromFetch;
        });
      }
      return data;
    },
  },
  mounted() {},
  created() {},
  beforeDestroy() {},

  computed: {
    ...mapState("translationModule", ["dataLang"]),
  },
};
</script>
